module.exports = __webpack_public_path__ + "static/media/iconOperation.9e26ff6a.svg";